import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Dashboard from '../../screens/Dashboard'
import PrivateRoute from '../routing/PrivateRoute'
import TeacherPrivateRoute from '../routing/TeacherPrivateRoute'
import AdminPrivateRoute from '../routing/AdminPrivateRoute'
import ProfileFormScreen from '../../screens/ProfileFormScreen.tsx'
import LogInScreen from '../../screens/LogInScreen.tsx'
import RegisterScreen from '../../screens/RegisterScreen'
import ForTeacherScreen from '../../screens/teachers/ForTeacherScreen'
import TeacherRegisterForm from '../../screens/teachers/TeacherRegisterForm/TeacherRegisterForm'
import DashboardTeacher from '../../screens/teachers/DashboardTeacher/DashboardTeacher'
import LoginTeacher from '../../screens/teachers/LoginTeacher.tsx'
import ProfileTeacher from '../../screens/teachers/ProfileTeacherForm/ProfileTeacher.tsx'
import ForgotPasswordScreen from '../../screens/ForgotPasswordScreen'
import ResetPasswordScreen from '../../screens/ResetPasswordScreen'
import ConfirmationSuccessScreen from '../../screens/ConfirmationSuccessScreen'
import TeacherConfirmationSuccessScreen from '../../screens/TeacherConfirmationSuccessScreen'
import RequestResendConfirmationTokenScreen from '../../screens/RequestResendConfirmationTokenScreen'
import RequestTeacherResendConfirmationTokenScreen from '../../screens/teachers/RequestTeacherResendConfirmationTokenScreen'
import TeachersListScreen from '../../screens/TeachersList/TeachersListScreen'
import NotFound from '../layout/NotFound'
import Lessons from '../lessons/Lessons.tsx'
import AddALesson from '../lessons/AddALesson/AddALesson'
import EditALesson from '../lessons/EditALesson/EditALesson'
import ReuploadLessonDocuments from '../lessons/EditALesson/ReuploadLessonDocuments'
import BookLearningTime from '../students/BookLearningTime/BookLearningTime'
import SchedulingCalendar from '../teachers/BookingCalendar/SchedulingCalendar'
import LessonsManager from '../students/LessonsManager/LessonsManager'
import BookedLesson from '../students/bookedLesson/BookedLesson'
import BookedLessonsManager from '../teachers/bookedLessonsManager/BookedLessonsManager'
import BookedLessonInfo from '../teachers/bookedLessonInfo/BookedLessonInfo'
import TeacherInfo from '../teachers/teacherInfo/TeacherInfo'
import EditDegreeImages from '../../screens/teachers/ProfileTeacherForm/EditDegreeImages'
import ContactUs from '../layout/contactUs/ContactUs.tsx'
import LandingScreen from '../../screens/LandingScreen.tsx'
import VnpayReturn from '../students/BookLearningTime/PaymentMethods/VnpayReturn'
import ZaloPaySuccessScreen from '../Payments/ZaloPaySuccessScreen'
import HowToStudyScreen from '../../screens/student/HowToStudyScreen'
import HowToTeachScreen from '../../screens/teachers/HowToTeachScreen'
import HowToGetPaid from '../../screens/teachers/HowToGetPaidScreen'
import AdminLogin from '../../screens/admin/Login'
import DashboardAdmin from '../../screens/admin/DashboardAdmin'
import SomethingElse from '../../screens/admin/SomethingElse'
import BookedLessonDetails from '../../screens/admin/BookedLessonDetails'
import { MoMoSuccessPage } from '../../screens/Payment/MoMoSuccessPage'
import AboutYouSpeakScreen from '../../screens/AboutYouSpeakScreen'

const Routes = (props) => {
  return (
    <section>
      <Switch>
        <Route exact path="/" component={LandingScreen} />
        <Route exact path="/login" component={LogInScreen} />
        <Route exact path="/register-user" component={RegisterScreen} />
        <Route exact path="/forgot" component={ForgotPasswordScreen} />
        <Route exact path="/reset/:token" component={ResetPasswordScreen} />
        <Route
          exact
          path="/api/users/confirmation/:token"
          component={ConfirmationSuccessScreen}
        />
        <Route
          exact
          path="/users/request-resend-confirmation-token"
          component={RequestResendConfirmationTokenScreen}
        />
        <Route exact path="/contact-us" component={ContactUs} />

        <Route exact path='/about-us' component={AboutYouSpeakScreen} />

        <Route
          exact
          path="/teachers/how-to-teach"
          component={HowToTeachScreen}
        />
        <Route
          exact
          path="/teachers/how-to-get-paid"
          component={HowToGetPaid}
        />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute
          exact
          path="/create-profile"
          component={ProfileFormScreen}
        />
        <PrivateRoute
          exact
          path="/book-learning-time/:teacherCalendarId"
          component={BookLearningTime}
        />

        <PrivateRoute
          exact
          path="/teachers/english"
          component={TeachersListScreen}
        />

        <PrivateRoute
          exact
          path="/students/lessons-manager"
          component={LessonsManager}
        />

        <PrivateRoute
          exact
          path="/students/bookedLesson/:bookedLessonId"
          component={BookedLesson}
        />
        <PrivateRoute exact path="/vnpay-return" component={VnpayReturn} />
        <PrivateRoute
          exact
          path="/zaloPay/success"
          component={ZaloPaySuccessScreen}
        />
        <PrivateRoute exact path='/MoMoPay/success' component={MoMoSuccessPage} />
        <Route
          exact
          path="/student/how-to-study"
          component={HowToStudyScreen}
        />

        {/* Teacher routes */}
        <Route exact path="/for-teacher" component={ForTeacherScreen} />
        <Route exact path="/teachers/login" component={LoginTeacher} />
        <Route
          exact
          path="/teachers/register-teacher"
          component={TeacherRegisterForm}
        />
        <Route
          exact
          path="/teachers/confirmation/:token"
          component={TeacherConfirmationSuccessScreen}
        />
        <Route
          exact
          path="/teachers/request-resend-confirmation-token"
          component={RequestTeacherResendConfirmationTokenScreen}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/create-profile"
          component={ProfileTeacher}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/dashboard"
          component={DashboardTeacher}
        />

        <TeacherPrivateRoute
          exact
          path="/teachers/lessons"
          component={Lessons}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/add-a-lesson"
          component={AddALesson}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/lessons/edit/:id"
          component={EditALesson}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/lessons/re-upload-documents/:id"
          component={ReuploadLessonDocuments}
        />
        <TeacherPrivateRoute
          exact
          path="/booking-calendar-teacher"
          component={SchedulingCalendar}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/booked-lessons-manager"
          component={BookedLessonsManager}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/bookedLesson/:bookedLessonId"
          component={BookedLessonInfo}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/:teacherProfileId"
          component={TeacherInfo}
        />
        <TeacherPrivateRoute
          exact
          path="/teachers/dashboard/edit-degree-images"
          component={EditDegreeImages}
        />

        <AdminPrivateRoute exact path='/admin/dashboard' component={DashboardAdmin} />
        <AdminPrivateRoute exact path='/admin/somethingElse' component={SomethingElse} />
        <AdminPrivateRoute exact path='/admin/bookedLessonDetails/:id' component={BookedLessonDetails} />

        <Route exact path="/admin/login" component={AdminLogin} />
        <Route component={NotFound} />
      </Switch>
    </section>
  )
}

export default Routes
